import { DropdownEditor, Field, TextEditor } from '@approvalmax/ui';
import { PlainDataProvider } from 'modules/data-providers';
import { memo } from 'react';

import { WrapFieldRow } from '../../RequestSearchPopup.styles';
import { messages } from './StandaloneSearchFields.messages';
import { StandaloneSearchFieldsProps } from './StandaloneSearchFields.types';

export const StandaloneSearchFields = memo<StandaloneSearchFieldsProps>((props) => {
    const { company, params, updateParameter, disabled } = props;

    return (
        <WrapFieldRow>
            <Field title={messages.requestorFieldTitle}>
                <PlainDataProvider items={company?.allMembers || []} filterAttribute='displayName'>
                    <DropdownEditor
                        displayAttribute='displayName'
                        placeholder={messages.requestorPlaceholder}
                        value={params.requestor}
                        onChange={updateParameter('requestor')}
                        disabled={disabled}
                    />
                </PlainDataProvider>
            </Field>

            <Field title={messages.standaloneRequestNameFieldTitle}>
                <TextEditor
                    placeholder={messages.standaloneRequestNamePlaceholder}
                    value={params.standaloneRequestName}
                    onChange={updateParameter('standaloneRequestName')}
                    disabled={disabled}
                />
            </Field>

            <Field title={messages.standaloneRequestDescriptionFieldTitle}>
                <TextEditor
                    placeholder={messages.standaloneRequestDescriptionPlaceholder}
                    value={params.standaloneRequestDescription}
                    onChange={updateParameter('standaloneRequestDescription')}
                    disabled={disabled}
                />
            </Field>
        </WrapFieldRow>
    );
});

StandaloneSearchFields.displayName = 'StandaloneSearchFields';
